import React from 'react';
import SubmitClaimWizard from './SubmitClaimWizard';

const JoinContact = () => {
  return <SubmitClaimWizard initialStep={3} />;
};

export default JoinContact;
